import { buildBillingContext } from '@/apiCalls/billingContext';
import { postUrl } from '@/apiCalls/fetch';
import { selectCountry } from '@/context/display';
import { store } from '@/context/store';

import { ILookupAbnOrAcn } from '../commonTypes';

export async function lookupAbn(
    abn: string
): Promise<ILookupAbnOrAcn | undefined> {
    const country = selectCountry(store.getState());

    return postUrl<ILookupAbnOrAcn>('/api/abn/detail', {
        country,
        abn,
        billingContext: buildBillingContext(),
    });
}
